import { millisecondsInMinute } from 'date-fns';

import { useAuthRecovery } from '#/features/auth/auth-recovery-handler';
import { useJwtTokenRefreshHandler } from '#/features/auth/jwt-token-refresh-handler';
import { useJwtTokenExpirationHandler } from '#/features/auth/jwt-token-expiration-handler';

const JWT_TOKEN_REFRESH_PERIOD_MS = millisecondsInMinute * 4;

export default function AuthManager() {
  useAuthRecovery();
  useJwtTokenExpirationHandler();
  useJwtTokenRefreshHandler(JWT_TOKEN_REFRESH_PERIOD_MS);

  return null;
}
